import React, { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./Home/Home";
import Quiz_home from "./Quiz_Page/Quiz_home";
import Header from "./Home/Header";
import Footer from "./Home/Footer";
import Ques_box from "./Quiz_Page/Components/Ques_box";
import Result from "./Quiz_Page/Components/Result";
import { QuizContext } from "./Quiz_Page/Context/QuizContext";

const Routing = () => {
  const { quizData } = useContext(QuizContext);
  const { name, email } = quizData;
  console.log(name, email);

  return (
    <BrowserRouter>
      <Header />
      <hr />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/Quiz_home"
          element={name ? <Quiz_home /> : <Navigate to="/" />}
        />
        <Route path="/Ques_box" element={<Ques_box />} />
        <Route path="/Result" element={<Result />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default Routing;
